import Button from './shared/Button.jsx';
import { formatEuros, formatRelative } from '../lib/format.js';

export default function ProductCard({ product, onEditConnection, onEditPlans, onDelete, onTogglePause, onRegenerateToken, onSyncUsers, onShowUsers }) {
  const tone = computeTone(product);

  return (
    <div class={`product-card status-${tone}`}>
      <div class="product-card-head">
        <div>
          <h3 class="product-card-title">{product.name}</h3>
          <div class="product-card-slug muted">{product.slug}</div>
        </div>
        <div class={`status-pill status-pill-${tone}`} title={product.lastError || ''}>
          <span class="status-dot" />
          {labelFor(tone)}
        </div>
      </div>

      {product.description && <p class="product-card-description">{product.description}</p>}

      <div class="product-card-meta muted">
        <div><strong>URL:</strong> {product.baseUrl}</div>
        <div><strong>Laatste check:</strong> {formatRelative(product.lastCheckAt)}</div>
        {product.lastError && <div class="product-card-error"><strong>Fout:</strong> {product.lastError}</div>}
        <div><strong>Laatste sync:</strong> {formatRelative(product.lastUserSyncAt)}</div>
        {product.lastUserSyncError && <div class="product-card-error"><strong>Sync-fout:</strong> {product.lastUserSyncError}</div>}
        {/* Pakketten en afdelingen (/api/4u/accounts): mislukt dat, dan houdt de factuurrun regels in */}
        {product.lastAccountsSyncError && <div class="product-card-error"><strong>Pakketten en afdelingen niet opgehaald:</strong> {product.lastAccountsSyncError}</div>}
      </div>

      {/* Why: registreren legt alleen de technische koppeling vast. Zonder
          prijzen is een product niet verkoopbaar en verschijnt het nergens —
          niet op de aanvraagpagina en niet in de abonnementenkeuze. Die
          onafheid als waarschuwing tonen in plaats van als grijze mededeling,
          en meteen doorklikbaar naar het scherm dat het oplost. */}
      {product.isSellable ? (
        <div class="product-card-pricing">
          {product.plans.filter(p => p.isSellable).map(plan => (
            <span key={plan.id} class="price-badge" title={plan.maxUsers == null ? 'Onbeperkt' : `Tot en met ${plan.maxUsers} gebruikers`}>
              {plan.name} · {formatEuros(plan.monthlyPriceCents)} p/m
              <span class="price-badge-limit">
                {plan.maxUsers == null ? '∞' : `≤${plan.maxUsers}`}
              </span>
            </span>
          ))}
        </div>
      ) : (
        <button type="button" class="product-card-todo" onClick={() => onEditPlans(product)}>
          <strong>Nog geen verkoopbaar pakket.</strong> Dit product kan niet worden
          verkocht of op een abonnement gezet. Pakketten instellen →
        </button>
      )}

      <button type="button" class="product-card-users" onClick={() => onShowUsers(product)}>
        {product.userCount} {product.userCount === 1 ? 'gebruiker' : 'gebruikers'}
      </button>

      <div class="product-card-actions">
        <Button size="sm" variant="ghost" onClick={() => onEditConnection(product)}>Koppeling</Button>
        <Button size="sm" variant="ghost" onClick={() => onEditPlans(product)}>Pakketten</Button>
        <Button size="sm" variant="ghost" onClick={() => onTogglePause(product)}>
          {product.paused ? 'Hervatten' : 'Pauzeren'}
        </Button>
        <Button size="sm" variant="ghost" onClick={() => onSyncUsers(product)}>Sync nu</Button>
        <Button size="sm" variant="ghost" onClick={() => onRegenerateToken(product)}>Nieuwe token</Button>
        <Button size="sm" variant="ghost" onClick={() => onDelete(product)}>Verwijderen</Button>
      </div>
    </div>
  );
}

function computeTone(product) {
  if (product.paused) return 'paused';
  if (product.status === 'up' && isFresh(product.lastCheckAt)) return 'up';
  if (product.status === 'up') return 'stale';
  if (product.status === 'down') return 'down';
  return 'unknown';
}

function labelFor(tone) {
  switch (tone) {
    case 'up': return 'OK';
    case 'stale': return 'Niet vers';
    case 'down': return 'Down';
    case 'paused': return 'Gepauzeerd';
    default: return 'Onbekend';
  }
}

function isFresh(iso) {
  if (!iso) return false;
  const ageSec = (Date.now() - new Date(iso).getTime()) / 1000;
  return ageSec >= 0 && ageSec < 60;
}
